import { Component, OnInit } from '@angular/core';
import { fadeIn } from 'src/app/animations';
import { variableAnnuity } from 'src/app/shared/constants/simon-education-nav-items.constants';
import { SimonIframeUrl } from 'src/app/shared/models/simon-iframe-url.models';

@Component({
  animations: [fadeIn],
  selector: 'app-variable-annuities',
  templateUrl: './variable-annuities.component.html',
})
export class VariableAnnuitiesComponent {
  navItems: SimonIframeUrl[] = variableAnnuity;

  constructor() { }

}
